// app/frontend/components/EventForm/sections/LinksSection.tsx
import { Accordion, Group, Text, TextInput } from '@mantine/core';
import { IconLink } from '@tabler/icons-react';
import { LinksSectionProps } from '../types';

const LinksSection: React.FC<LinksSectionProps> = ({ form }) => {
  return (
    <Accordion multiple className="form-accordion">
      <Accordion.Item value="website-links">
        <Accordion.Control>
          <Group gap="xs">
            <IconLink size={20} />
            <Text style={{ fontSize: '1.25rem', fontWeight: 'bold' }}>Links</Text>
          </Group>
        </Accordion.Control>
        <Accordion.Panel>
          <TextInput
            label="Website Link"
            name="website_url"
            styles={{ label: { color: '#FFF7ED' } }}
            placeholder="Enter the event website."
            {...form.getInputProps('website_url')}
            mt="md"
          />

          <TextInput
            label="Passes Link"
            name="ticket_url"
            styles={{ label: { color: '#FFF7ED' } }}
            placeholder="Enter the link to purchase passes."
            {...form.getInputProps('ticket_url')}
            mt="md"
          />

          <TextInput
            label="Facebook Event Link"
            name="facebook_url"
            styles={{ label: { color: '#FFF7ED' } }}
            placeholder="Enter the link to Facebook event."
            {...form.getInputProps('facebook_url')}
            mt="md"
          />

          <TextInput
            label="Instagram Link"
            name="instagram_url"
            styles={{ label: { color: '#FFF7ED' } }}
            placeholder="Enter the link to the event Instagram page."
            {...form.getInputProps('instagram_url')}
            mt="md"
          />

          <TextInput
            label="Meetup Link"
            name="meetup_url"
            styles={{ label: { color: '#FFF7ED' } }}
            placeholder="Enter the link to Meetup event."
            {...form.getInputProps('meetup_url')}
            mt="md"
          />

          <TextInput
            label="Tiktok Link"
            name="tiktok_url"
            styles={{ label: { color: '#FFF7ED' } }}
            placeholder="Enter the link to the event Tiktok event page."
            {...form.getInputProps('tiktok_url')}
            mt="md"
          />
        </Accordion.Panel>
      </Accordion.Item>
    </Accordion>
  );
};

export default LinksSection;
